import { get, rawXhrRequest, xhrPut, put, post, del } from './requests'

const resourcePath = 'document_files'

export function createDocumentFile (data) {
  return post(`${resourcePath}`, { document_file: data })
}

export function showDocumentFile (id) {
  return get(`${resourcePath}/${id}`)
}

export function showDocumentFileS3Upload (id) {
  return get(`${resourcePath}/${id}/s3_upload`)
}

export function updateDocumentFile (id) {
  return put(`${resourcePath}/${id}`)
}

export function updateDocumentFilePosition (id, position) {
  return put(`${resourcePath}/${id}/update_position`, { position })
}

export function replaceDocumentFile (id, data) {
  return put(`${resourcePath}/${id}/replace_file`, { document_file: data })
}

export function uploadDocumentFileToS3 (id, file, s3Upload, handleProgress) {
  const { url, fields } = s3Upload
  const { key, policy, xAmzCredential, xAmzAlgorithm, xAmzDate, xAmzSignature, contentType } = fields
  const formData = new FormData()
  formData.append('x-amz-algorithm', xAmzAlgorithm)
  formData.append('x-amz-credential', xAmzCredential)
  formData.append('x-amz-date', xAmzDate)
  formData.append('x-amz-signature', xAmzSignature)
  formData.append('content-type', contentType)
  formData.append('key', key)
  formData.append('policy', policy)
  formData.append('file', file)

  return rawXhrRequest(url, { formData, handleProgress })
}

export function uploadDocumentFile (id, file, handleProgress) {
  const formData = new FormData()
  formData.append('document_file[file]', file)

  return xhrPut(`${resourcePath}/${id}`, formData, handleProgress)
}

export function deleteDocumentFile (id) {
  return del(`${resourcePath}/${id}`)
}
